<template>
  <v-container style="max-width: 1280px;">
    <CardUI>
      <template v-slot:header>
        <h4>Ведомость группы</h4>
      </template>
      <template v-slot:body>
        <div class="table_wrapper">
          <table class="table_group">
            <thead class="table_header">
              <tr style="">
                <th rowspan="2" style="border-top: 1px solid #eaeaea;">Студент</th>
                <th rowspan="2" style="border-top: 1px solid #eaeaea;">Проект</th>
                <th :colspan="goals.length" style="border-top: 1px solid #eaeaea;">Контрольные точки ({{ goals.length }})</th>
                <th rowspan="2" style="border-top: 1px solid #eaeaea;">Оценка</th>
              </tr>
              <tr>
                <th v-for="goal in goals" :key="goal.id">
                  <div>{{ goal.name }}</div>
                  <div style="font-size: 12px">{{ goal.description }}</div>
                  <div v-if="getDeadlineFromAnyProject(goal.id)" style="font-size: 10px; margin-top: 5px">
                    до {{ $moment.utc(getDeadlineFromAnyProject(goal.id)).local().format('DD.MM.YYYY') }}
                  </div>
                </th>
              </tr>
            </thead>
            <tbody v-for="student in students" :key="student.id">
            <tr v-for="(project, index) in student.active_projects" :key="project.id">
              <td v-if="!index" :rowspan="student.active_projects.length">
                <UserLinkComponent :user="student"/>
              </td>
              <td>
                <a target="_blank" :href="'/#/projects/'+project.id"> {{ project.title }}</a>
                <div style="font-size: 10px">
                  создан {{ $moment.utc(project.created_at).local().format('DD.MM') }}
                </div>
              </td>
              <td v-for="goal in goals" :key="goal.id">
                <div :key="index"
                     v-for="(item, index) in getGoalFromProjectById(project, goal.id) ? [getGoalFromProjectById(project, goal.id)] : []">
                  <GoalProgressBar :goal="item"/>
                </div>
              </td>
              <td>{{ project.rating || '-' }}</td>
            </tr>
            <tr v-if="!student.active_projects.length">
              <td>
                <UserLinkComponent :user="student"/>
              </td>
              <td>
                Проекта нет
              </td>
              <td v-for="goal in goals" :key="goal.id">
                -
              </td>
              <td>
                -
              </td>
            </tr>
            </tbody>

          </table>
        </div>
      </template>
    </CardUI>

  </v-container>
</template>

<script>

import opd from "@/api/opd.js";
import UserLinkComponent from "@/components/Profile/UserLinkComponent.vue";
import GoalProgressBar from "@/components/Opd/GoalProgressBar.vue";
import analytics from "@/api/analytics.js";
import CardUI from "@/components/UI/CardUI";

export default {
  components: {CardUI, UserLinkComponent, GoalProgressBar},
  name: "OpdGroupPageComponent",
  data() {
    return {
      students: [],
      goals: []
    }
  },
  methods: {
    getGoalFromProjectById(project, goal_id) {
      return project.goals.filter((g) => g.id === goal_id).shift();
    },
    getDeadlineFromAnyProject(goalId) {
      for (const student of this.students) {
        for (const project of student.active_projects || []) {
          const goal = project.goals.find(g => g.id === goalId);
          if (goal && goal.pivot && goal.pivot.deadline) {
            return goal.pivot.deadline;
          }
        }
      }
      return null;
    }

  },
  mounted() {
    if (!this.$store.getters.isAuth) {
      this.$router.push('/auth/login');
      return;
    }
    opd.goals().then((r) => {
      this.goals = r.data;
    }).catch(e => {
      alert(e);
    })

    opd.students(this.$route.params.id).then((r) => {
      this.students = r.data;
      analytics.openOpdGroupPage(this.$store.state.user.currentUser.id);
    }).catch(e => {
      alert(e);
    })
  }
}
</script>

<style scoped>
.table_wrapper {
  overflow-x: auto;
  overflow-y: auto;
  max-height: 80vh;
}

.table_group {
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
  text-align: center;
  border-left: 1px solid #eaeaea;
}

.table_header {
  position: sticky;
  top: 0;
  z-index: 5;
}

.table_header th, 
.table_group td {
  border-right: 1px solid #eaeaea;
  border-bottom: 1px solid #eaeaea;
  padding: 10px;
}

.table_header th {
  background-color: #fff;
  font-weight: normal;
}
</style>
